import { Navigate } from "react-router-dom";
import { useAuth } from "./auth_provider";

export const ProtectedRoute = ({ children }: { children: any}) => {
  const dependancies = useAuth();
  console.log(dependancies)
  if (dependancies === null || !dependancies.token) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  return children;
};